<template>
  <v-card height="100%">
    <v-card-title>
      Contact Information
      <v-spacer></v-spacer>
      <v-img
        max-height="50"
        max-width="50"
        :src="adminUserView.avatarImage"
      ></v-img>
    </v-card-title>

    <v-card-text>
      <v-list-item v-if="adminUserView.fullName">
        <v-list-item-content>
          <v-list-item-title>Full Name (Deprecated)</v-list-item-title>
          <v-list-item-subtitle>{{ adminUserView.fullName }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Email Address
            <v-icon
              small
              color="green"
            >
              mdi-check-bold
            </v-icon>
          </v-list-item-title>
          <v-list-item-subtitle>{{ adminUserView.emailAddress }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Name
          </v-list-item-title>
          <v-list-item-subtitle>{{ adminUserView.firstName }} {{ adminUserView.lastName }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="adminUserView.profile.phoneNumber">
        <v-list-item-content>
          <v-list-item-title>
            Phone Number
            <v-icon
              small
              color="green"
            >
              mdi-check-bold
            </v-icon>
          </v-list-item-title>
          <v-list-item-subtitle>{{ adminUserView.profile.phoneNumber }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Physical Address
            <v-icon
              v-if="adminUserView.profile.addressLine1"
              small
              color="green"
            >
              mdi-check-bold
            </v-icon>
            <v-icon
              v-else
              small
              color="error"
            >
              mdi-alert-circle
            </v-icon>
          </v-list-item-title>
          <v-list-item-subtitle v-if="adminUserView.profile.addressLine1">
            <div>{{ adminUserView.profile.addressLine1 }}</div>
            <div v-if="adminUserView.profile.addressLine2">{{ adminUserView.profile.addressLine2 }}</div>
            <div>{{ adminUserView.profile.addressCity }}, {{ adminUserView.profile.addressState }} {{ adminUserView.profile.addressPostalCode }}</div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Identity Information
            <v-icon
              v-if="adminUserView.profile.complete"
              small
              color="green"
            >
              mdi-check-bold
            </v-icon>
            <v-icon
              v-else
              small
              color="error"
            >
              mdi-alert-circle
            </v-icon>
          </v-list-item-title>
          <v-list-item-subtitle  v-if="adminUserView.profile.complete">●●● - ●● - ●●●●</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'UserDetails',

    computed: {
      ...mapGetters([
        'adminUserView'
      ])
    },
  }
</script>
